import { render, staticRenderFns } from "./TaxesForm.vue?vue&type=template&id=235a138f&"
import script from "./TaxesForm.vue?vue&type=script&lang=js&"
export * from "./TaxesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports